<template>
<div class="content">
    <div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
        <nte-manual-input>
        </nte-manual-input> 
        </div>
    </div>  
    </div>
</div>
</template>
<script>
/* eslint-disable */
import nteManualInput from './todo-nte-manual-input'
export default {
    components: {
        nteManualInput
    }
}
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-employee-management/base-nte-manual-input.vue